import React, { useEffect, useState, useContext } from "react";
import Gender from "./components/Gender";
import ProgressBar from "./components/ProgressBar";
import Birthday from "./components/Birthday";
import Name from "./components/Name";
import Email from "./components/Email";
import Password from "./components/Password";
import Result from "./components/Result";
import { simplyClick, getTTI, sendScreenResolution } from "./helpers";
import { landingId } from "./constants/constans";
import { useAppendLandingId } from "./hooks/useAppendLandingId";
import { ContextProfileUser } from "./lib/profileContext";
import { useSessionData } from "ui-components";
import { EventsSignIn } from "./constants/constans"

function App() {
  const [step, setStep] = useState(1);
  let content = null;

  useAppendLandingId(landingId);

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useEffect(() => {

    if (window.location.search !== "") {
      const signInButton = document.querySelector(".sign-in");
      signInButton?.setAttribute("href", `/login/${window.location.search}`);
    }

    const element = document.getElementById("translation-checkpoint");
    if (!element) return;

    const initText = element.textContent?.trim() ?? "";
    let previousText = initText;

    const observer = new MutationObserver(() => {
      const currentText = element.textContent?.trim() ?? "";
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "already_have_an_account",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    return () => {
      observer.disconnect();
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    const signInButton = document.querySelector(".sign-in");
    const search = window.location.search;
    const lndId =
      search === ""
        ? `?landing_id=${landingId}`
        : `${search}&landing_id=${landingId}`;

    if (signInButton) {
      signInButton.setAttribute("href", `/login${lndId}`);
    }
  }, []);

  useEffect(() => {
    const signInButton = document.querySelector(".sign-in");
    if (!signInButton) return;

    const handleClick = () => {
      const eventName = EventsSignIn[step];
      if (eventName) {
        simplyClick(eventName);
      }
    };

    signInButton.addEventListener("click", handleClick);

    return () => {
      signInButton.removeEventListener("click", handleClick);
    };
  }, [step]);

  switch (step) {
    case 1:
      content = <Gender setStep={setStep} step={step} />;
      break;
    case 2:
      content = <Birthday setStep={setStep} step={step} />;
      break;
    case 3:
      content = <Name setStep={setStep} step={step} />;
      break;
    case 4:
      content = <Email setStep={setStep} step={step} />;
      break;
    case 5:
      content = <Password setStep={setStep} step={step} />;
      break;
    case 6:
      content = <Result />;
      break;
    default:
  }

  return (
    <>
      <ProgressBar step={step} />
      {content}
    </>
  );
}

export default App;
